import { SearchFilterField } from '@components/cockpit/panels/notificationSearch/filterComponents/SearchFilterField';
import { SearchFilterOptionEnum } from '@components/cockpit/panels/notificationSearch/notificationSearch.types';
import { useNotificationSearchContext } from '@components/cockpit/panels/notificationSearch/NotificationSearchContext';
import { useIntl } from 'react-intl';

export const PlatformFilter = () => {
  const { formatMessage } = useIntl();
  const { setActiveSearchFilterField } = useNotificationSearchContext();
  const field = SearchFilterOptionEnum.PLATFORM;

  return (
    <SearchFilterField
      name={field}
      label={formatMessage({ id: 'components.notificationSearch.filters.platforms' })}
      onClick={() => setActiveSearchFilterField(field)}
    />
  );
};

interface IdentifierFilterProps {
  isCollaborative?: boolean;
}

export const IdentifierFilter = ({ isCollaborative = false }: Readonly<IdentifierFilterProps>) => {
  const { formatMessage } = useIntl();
  const { setActiveSearchFilterField } = useNotificationSearchContext();
  const field = isCollaborative ? SearchFilterOptionEnum.COLLABORATIVE_ID : SearchFilterOptionEnum.ID;

  return (
    <SearchFilterField
      name={field}
      label={formatMessage({
        id: `components.notificationSearch.filters.searchFilters.type.${field}.plural`,
      })}
      onClick={() => setActiveSearchFilterField(field)}
    />
  );
};

export const ZoneFilter = () => {
  const { setActiveSearchFilterField } = useNotificationSearchContext();
  const { formatMessage } = useIntl();
  const field = SearchFilterOptionEnum.ZONES;

  return (
    <SearchFilterField
      name={field}
      label={formatMessage({ id: 'components.notificationSearch.filters.filterOptions.zones.title' })}
      onClick={() => setActiveSearchFilterField(field)}
    />
  );
};

export const SensorFilter = () => {
  const { formatMessage } = useIntl();
  const { setActiveSearchFilterField } = useNotificationSearchContext();
  const field = SearchFilterOptionEnum.TRACK_SENSOR;

  return (
    <SearchFilterField
      name={field}
      label={formatMessage({ id: 'components.notificationSearch.filters.sensors.title' })}
      onClick={() => setActiveSearchFilterField(field)}
    />
  );
};
